

































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import axios from "@/api/AuthAPI/auth-request-api";

import { deleteElement } from "@/api/delite/delite-element";
import { IFilmCategory as ICat } from "@/@types/cinema/film-category";
import { IFilm } from "@/@types/cinema/films";
import { IAlert } from "@/@types/_shared/shared";
import { multimedia } from "@/config/host.config";

@Component({})
export default class CinemaPage extends Vue {
  @Provide("bgFolder") bgFolder = "cinema/bg";
  @Provide("posterFolder") posterFolder = "cinema/poster";
  @Provide("logoFolder") logoFolder = "cinema/logo";
  @Provide("categoryFolder") categoryFolder = "cinema/category";

  deleted = false;
  deletedCat = false;
  loading = true;
  categoryList: Array<ICat> = [];
  cinemaList: Array<IFilm> = [];
  activeCategory = "";
  alerts: IAlert = {
    show: false,
    variant: "danger",
    message: String(this.$t("alerts.emptyUpdate")),
  };

  onSuccess(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("error.200")),
    });
  }

  onError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  updateCategorysSortOrder(): void {
    for (let i = 0; i < this.categoryList.length; i++) {
      this.updateCategory({ sort_order: i }, this.categoryList[i]._id);
    }
  }

  async updateMovie(id: string, data: Partial<IFilm>): Promise<void> {
    if (this.deleted) return;
    const uri = id ? multimedia.films + id : multimedia.films;
    const method = id ? "put" : "post";

    try {
      const mouvie = await axios[method](uri, data);
      if (mouvie.status === 200) {
        this.onSuccess();
        this.$bvModal.hide("movie-form");
        if (!id) {
          this.cinemaList.unshift(mouvie.data);
          return;
        }
        const i = this.cinemaList.findIndex((m) => m._id == id);
        if (i < 0) return this.createCinemaList();
        this.$set(this.cinemaList, i, mouvie.data);
      }
    } catch (error) {
      this.onError();
      console.log(error);
    }
  }

  async restoreMovie(id: string): Promise<void> {
    if (!this.deleted) return;
    const uri = multimedia.restore_movie + id;
    try {
      const res = await this.$axios.put(uri);
      if (res.status === 200) {
        this.onSuccess();
        this.mustDeleteMovie(id);
      }
    } catch (error) {
      console.error(error);
      this.onError();
    }
  }

  deleteFilm(id: string): void {
    const uri = this.deleted ? multimedia.forceDelete : multimedia.recucler;
    deleteElement(id, uri)
      .then(() => {
        this.onSuccess();
        this.mustDeleteMovie(id);
      })
      .catch(() => this.onError);
  }

  deletedCategory(id: string): void {
    const uri = this.deletedCat
      ? multimedia.forceCategory
      : multimedia.categorys;
    deleteElement(id, uri)
      .then(() => {
        this.onSuccess();
        this.mustDeleteCategory(id);
      })
      .catch(() => this.onError());
  }

  async mustDeleteMovie(id: string): Promise<void> {
    const i = this.cinemaList.findIndex((el) => el._id == id);
    if (i < 0) return this.createCinemaList();
    this.cinemaList.splice(i, 1);
  }

  async mustDeleteCategory(id: string): Promise<void> {
    const i = this.categoryList.findIndex((el) => el._id == id);
    if (i < 0) return this.createCategoryList();
    this.categoryList.splice(i, 1);
  }

  async updateCategory(data: Partial<ICat>, id: string): Promise<void> {
    const uri = id ? `${multimedia.categorys}/${id}` : multimedia.categorys;
    const method = id ? "put" : "post";

    try {
      const res = await this.$axios[method](uri, data);
      if (res.status === 200) {
        this.onSuccess();
        this.$bvModal.hide("movie-category-form");
        if (!id) {
          this.categoryList.unshift(res.data);
          return;
        }
        const i = this.categoryList.findIndex((m) => m._id == id);
        if (i < 0) return this.createCategoryList();
        this.$set(this.categoryList, i, res.data);
      }
    } catch (error) {
      console.error(error);
      this.onError();
    }
  }

  @Watch("deleted")
  async createCinemaList(): Promise<void> {
    this.loading = true;
    const uri = multimedia.films;
    const params = { "match[deleted][value]": this.deleted };
    try {
      const cinemares = await this.$axios.get(uri, { params });
      if (cinemares.status === 200) {
        this.cinemaList = cinemares.data;
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @Watch("deletedCat")
  async createCategoryList(): Promise<void> {
    const uri = multimedia.categorys;
    const params = { "match[deleted][value]": this.deletedCat };
    try {
      const res = await this.$axios.get(uri, { params });
      if (res.status === 200) this.categoryList = res.data;
    } catch (error) {
      console.log(error);
    }
  }

  mounted(): void {
    this.createCinemaList();
    this.createCategoryList();
  }
}
